import { DATE_FORMAT } from '@new-ventures/constants';
import { parse, format } from 'date-fns';

export const formatDate = (date: string, newFormat?: string) =>
  format(parse(date, DATE_FORMAT, new Date()), newFormat ?? DATE_FORMAT);
